import { CHANGE_STORE_DATA_ANALYSE_TIME_RANGE } from "../actions/dataAnalyseTimeRangeActions";

import { states } from "./queriesStates";
import getDates from "./../shared/services/date.service";

const initialState = {
  dataState: states.NOT_REQUESTED,
  dataAnalyseTimeRange: {
    rangeStartDate: getDates.getNullTimeDate(new Date()),
    rangeEndDate: getDates.getNullTimeDate(new Date()),
    rangeStartTime: getDates.getNullTimeDate(new Date()),
    rangeEndTime: getDates.getEndDayTimeDate(new Date()),
  },
};

const dataAnalyseTimeRangeReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_STORE_DATA_ANALYSE_TIME_RANGE: {
      const { name, value } = action.payload;
      const dataAnalyseTimeRange = Object.assign({}, state.dataAnalyseTimeRange);

      typeof name === "object"
        ? name.map((item, index) => {
            dataAnalyseTimeRange[item] = value[index];
            return null;
          })
        : (dataAnalyseTimeRange[name] = value);

      return Object.assign({}, state, {
        dataState: states.READY,
        dataAnalyseTimeRange: dataAnalyseTimeRange,
      });
    }
    default:
      return state;
  }
};

export default dataAnalyseTimeRangeReducer;
